import gql from 'graphql-tag'

export default gql`
  mutation CreateGame($players: [PlayerInput!]!, $playersCount: Int!, $type: String!) {
    createGame(players: $players, playersCount: $playersCount, type: $type) {
      id
    }
  }
`
